import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const listCognitoUsers = async ({}) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/listUserpool', {}, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const listAllGroupsQuery = async () => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Group/list', {}, apiRef);
        debug && console.log('CG query results', response);
    }
    catch (e) {
        debug && console.log('Error in CG query', e);
        response.err = e;
    }
    return response;
};
const listUsers = async ({ contextCustomer, contextUser, ExclusiveStartKey, limit, listAdminsOnly }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/list', { contextCustomer, contextUser, ExclusiveStartKey, limit, listAdminsOnly }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const getUser = async ({ contextCustomer, contextUser, requestedUser }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/get', { contextCustomer, contextUser, requestedUser }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * Updates the user info in the database
 *
 * Also updates user info in Cognito
 *
 * Doesn't update Cognito groups (roles), that's handled by {@link addUserToGroup | `addUserToGroup`} and {@link removeUserFromGroup | `removeUserFromGroup`}
 */
const updateUser = async ({ contextCustomer, contextUser, userToUpdate, makeAdministrator }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/update', { contextCustomer, contextUser, userToUpdate, makeAdministrator }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const addUser = async ({ addToGroups, contextUser, makeAdmin, temporaryPassword, user, contextCustomer, forceChange }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/add', { addToGroups, contextUser, makeAdmin, temporaryPassword, user, contextCustomer, forceChange }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    debug && console.log(`UserDAO addUserRes `, response);
    return response;
};
const deleteUser = async (userObject) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/delete', userObject, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    debug && console.log('UserDAO deleteUser response', response);
    return response;
};
const listGroupsForUser = async ({ Username }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/listGroups', { Username }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const addUserToGroup = async ({ username, GroupName }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/addToGroup', { username, GroupName }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const removeUserFromGroup = async ({ username, GroupName }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/removeFromGroup', { username, GroupName }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const setUserPassword = async ({ Password, UserPoolId, Username, Permanent }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/setUserPassword', { Password, UserPoolId, Username, Permanent }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/** @deprecated now handled by {@link updateUser | `updateUser`} */
const updateUserEdge = async ({ contextCustomer, contextUser, userToUpdate, makeAdministrator }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/User/updateEdge', { contextCustomer, contextUser, userToUpdate, makeAdministrator }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * **Device DAO**
 */
export const UserDAO = {
    listCognitoUsers,
    listUsers,
    getUser,
    updateUser,
    updateUserEdge,
    addUser,
    deleteUser,
    listGroupsForUser,
    addUserToGroup,
    removeUserFromGroup,
    setUserPassword,
    listAllGroupsQuery,
};
